import { TableCellProps } from '../models';
import styles from './invitedByCelll.module.scss';

function InvitedByCell({ row }: TableCellProps) {
  const invitedBy = row.original.createdByPersonFullName
    ? row.original.createdByPersonFullName
    : '...';
  return (
    <span className={styles.cell} title={invitedBy} data-exclude-lg>
      {invitedBy}
    </span>
  );
}

export default InvitedByCell;
